import { Address } from '../../../../data/models/user';

export enum InternalOnboardingStep {
	BASIC_INFO = 0,
	WORK_PERSONAL_PREFERENCES = 1,
	TRAVEL_INFO = 2,
	REVIEW = 3,
}

export enum InternalOnboardingStatus {
	FORM = 'FORM',
	SUBMITTING = 'SUBMITTING',
	SUCCESS = 'SUCCESS',
	ERROR = 'ERROR',
}

export interface InternalFormValues {
	// Basic Information - Name
	firstName: string;
	lastName: string;
	preferredName: string;
	preferredPronouns: string;

	// Basic Information - Contact Information
	email: string;
	personalEmail: string;
	phone: string;
	phoneCarrier: string;
	isIphone: string;
	smsTextReady: string;
	hasWhatsapp: string;
	whatsappNumber: string;
	hasWechat: string;
	wechatNumber: string;

	// Basic Information - Emergency Contact
	emergencyContactFirstName: string;
	emergencyContactLastName: string;
	emergencyContactPhone: string;

	// Basic Information - Home Address
	homeAddress: Address;

	// Basic Information - Shipping Address
	shippingIsSameAsHome: boolean;
	shippingAddress: Address;

	// Work & Personal Preferences - Work Details
	role: string;
	websiteUrl: string;
	instagramHandle: string;
	healthInsurance: string;
	professionalLicenses: string;

	// Work & Personal Preferences - Personal Preferences
	dietaryRestrictions: string;
	photographyConsent: string;
	shirtSize: string;
	pantSize: string;
	shoeSize: string;
	biopoc: string;

	// Travel Information - Airline Details
	homeAirport: string;
	preferredSeating: string;
	dateOfBirth: string;
	tsaPrecheck: string;
	globalEntry: string;
	passportNumber: string;
	passportIssuingCountry: string;
	passportExpirationDate: string;
	noPassport: boolean;
	preferredAirlines: string[];

	// Travel Information - Airline Numbers
	deltaMileage: string;
	unitedMileage: string;

	// Travel Information - Vehicle Information
	driversLicenseNumber: string;
	driversLicenseState: string;
	noDriversLicense: boolean;
	hasVehicle: string;
	willingToUseVehicleForProduction: string;
	vehicleType: string;
	vehicleLocation: string;
}
